import { PureComponent } from "react";
import classNames from "classnames";
import FlashesStore, { FlashItem } from "~/stores/FlashesStore";

type Props = {
  flash: FlashItem;
  onRemoveClick: (flash: FlashItem) => void;
};

export default class Flash extends PureComponent<Props> {
  render() {
    const flashClasses = {
      // @ts-expect-error - TS2339 - Property 'ERROR' does not exist on type 'FlashesStore'.
      [FlashesStore.ERROR]: "border-bkx-error-stroke bg-bkx-error text-bkx-error-foreground",
      // @ts-expect-error - TS2339 - Property 'WARNING' does not exist on type 'FlashesStore'.
      [FlashesStore.WARNING]:
        "border-bkx-warning-stroke bg-bkx-warning text-bkx-warning-foreground",
      // @ts-expect-error - TS2339 - Property 'SUCCESS' does not exist on type 'FlashesStore'.
      [FlashesStore.SUCCESS]:
        "border-bkx-success-stroke bg-bkx-success text-bkx-success-foreground",
    };

    const typeClasses =
      flashClasses[this.props.flash.type] ||
      "border-bkx-neutral-stroke bg-bkx-neutral text-bkx-neutral-foreground";
    const classes = classNames("flex items-center mb-2 border rounded-sm", typeClasses);

    return (
      <div className={classes}>
        <div className="min-w-0 flex-auto px-5 py-4" data-flash-message={true}>
          {this.props.flash.message}
        </div>
        <button className="btn px-5 py-4" onClick={this.handleCloseClick} data-flash-close={true}>
          Close
        </button>
      </div>
    );
  }

  handleCloseClick = () => {
    this.props.onRemoveClick(this.props.flash);
  };
}
